import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/logo.png';

const navItems = [
  { name: 'Features', path: '/features' },
  { name: 'Solutions', path: '/solutions' },
  { name: 'Demo', path: '/demo' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'About', path: '/about' },
];

function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <List>
      {navItems.map((item) => (
        <ListItem
          button
          component={RouterLink}
          to={item.path}
          key={item.name}
          onClick={handleDrawerToggle}
        >
          <ListItemText primary={item.name} />
        </ListItem>
      ))}
      <ListItem>
        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to="/contact"
          fullWidth
          sx={{
            bgcolor: '#F9B233',
            color: '#234734',
            fontWeight: 700,
            '&:hover': { bgcolor: '#e6a323' },
          }}
        >
          Book a Demo
        </Button>
      </ListItem>
    </List>
  );

  return (
    <>
      <AppBar
        position="sticky"
        elevation={2}
        sx={{
          bgcolor: '#fff8ec',
          color: '#234734',
          borderBottom: '2px solid #F9B233',
        }}
      >
        <Toolbar>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              flexGrow: 1,
              gap: 1.5,
            }}
          >
            <img
              src={logo}
              alt="Restro360"
              style={{
                height: '40px',
                background: 'transparent',
                display: 'block',
                padding: '2px 8px 2px 0',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                verticalAlign: 'middle',
              }}
            />
          </Box>

          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {navItems.map((item) => (
                <Button
                  key={item.name}
                  component={RouterLink}
                  to={item.path}
                  sx={{
                    color: '#234734',
                    fontWeight: 600,
                    fontSize: '1rem',
                    px: 2,
                    borderRadius: 2,
                    '&:hover': {
                      bgcolor: '#F9B233',
                      color: '#234734',
                    },
                  }}
                >
                  {item.name}
                </Button>
              ))}
              <Button
                variant="contained"
                component={RouterLink}
                to="/contact"
                sx={{
                  bgcolor: '#F9B233',
                  color: '#234734',
                  fontWeight: 700,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                  '&:hover': { bgcolor: '#ffe1a6', color: '#234734' },
                }}
              >
                Book a Demo
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          sx: { bgcolor: '#fff8ec', color: '#234734' },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

export default Navbar; 